import { render } from "./adddealer.vue?vue&type=template&id=1492dd22&scoped=true"
import script from "./adddealer.vue?vue&type=script&lang=js"
export * from "./adddealer.vue?vue&type=script&lang=js"

import "./adddealer.vue?vue&type=style&index=0&id=1492dd22&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1492dd22"]])

export default __exports__